import {InjectionToken} from '@angular/core';

/** Absolute portal route used when opening Content Library articles. */
export const CONTENT_LIBRARY_ROOT_ROUTE = new InjectionToken<string>('CONTENT_LIBRARY_ROOT_ROUTE', {
    providedIn: 'root',
    factory: () => '/content-library'
});
